import React from 'react'

const defaultValue = {
  userLoggedIn: false,
  pageConfigLoaded: false,
  extractingCoreStyles: false,
  dccSoftwares: [],
  showGenerationErrorDetails: false,
  modelReadyToasterEnabled: false,
  segmentationFlowEnabled: false,
  designerAssistEnabled: false,
  communityGalleryFilterOptions: {
    visibleCategories: [],
    sortOptions: [],
  },
  communityGalleryInitialModels: null,
}

const ThreeDStudioPageContext = React.createContext(defaultValue)

export default ThreeDStudioPageContext
